import { render, staticRenderFns } from "./score_table.vue?vue&type=template&id=cc2d3cee&scoped=true&"
import script from "./score_table.vue?vue&type=script&lang=ts&"
export * from "./score_table.vue?vue&type=script&lang=ts&"
import style0 from "./score_table.vue?vue&type=style&index=0&id=cc2d3cee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2d3cee",
  null
  
)

export default component.exports